export default "__VITE_ASSET__DgM5uD$5__"